import {DragDropModule} from '@angular/cdk/drag-drop';
import {CdkTableModule} from '@angular/cdk/table';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChip} from '@angular/material/chips';
import {MatDialogModule} from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSelectModule} from '@angular/material/select';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSliderModule} from '@angular/material/slider';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTreeModule} from '@angular/material/tree';
import {BadgeDialogComponent} from '@app/admin/badge-dialog/badge-dialog.component';
import {ContentAdminComponent} from '@app/admin/content-admin/content-admin.component';

import {TagModule} from '@app/tag/tag.module';
import {NgScrollbarModule} from 'ngx-scrollbar';

import {AdminRoutingModule} from './admin-routing.module';
import {AdminComponent} from './admin/admin.component';
import {AssetStreamDialogComponent} from './asset-stream-dialog/asset-stream-dialog.component';
import {BadgeCardComponent} from './badge-card/badge-card.component';
import {BillingAdminComponent} from './billing-admin/billing-admin.component';
import {ContentCardComponent} from './content-card/content-card.component';
import {DeleteCardComponent} from './delete-card/delete-card.component';
import {DeleteDialogComponent} from './delete-dialog/delete-dialog.component';
import {EditTagDialogComponent} from './edit-tag-dialog/edit-tag-dialog.component';
import {InviteDialogComponent} from './invite-dialog/invite-dialog.component';
import {MergeTagDialogComponent} from './merge-tag-dialog/merge-tag-dialog.component';
import {SiteCardComponent} from './site-card/site-card.component';
import {StorageDialogComponent} from './storage-dialog/storage-dialog.component';
import {StreamAdminComponent} from './stream-admin/stream-admin.component';
import {TagAdminComponent} from './tag-admin/tag-admin.component';
import {TagsCardComponent} from './tags-card/tags-card.component';
import {TransferDialogComponent} from './transfer-dialog/transfer-dialog.component';
import {UpgradeCardComponent} from './upgrade-card/upgrade-card.component';
import {UserAdminComponent} from './user-admin/user-admin.component';
import {UserDetailDialogComponent} from './user-detail-dialog/user-detail-dialog.component';
import {UserRoleDialogComponent} from './user-role-dialog/user-role-dialog.component';
import {UsersCardComponent} from './users-card/users-card.component';

@NgModule({
    imports: [
        CommonModule,
        AdminRoutingModule,
        MatSidenavModule,
        NgScrollbarModule,
        MatToolbarModule,
        MatListModule,
        MatButtonModule,
        ReactiveFormsModule,
        MatIconModule,
        TagModule,
        MatCardModule,
        MatInputModule,
        MatCheckboxModule,
        MatMenuModule,
        MatSelectModule,
        MatDialogModule,
        MatProgressBarModule,
        MatTableModule,
        MatSortModule,
        MatProgressSpinnerModule,
        MatPaginatorModule,
        MatSlideToggleModule,
        MatExpansionModule,
        CdkTableModule,
        DragDropModule,
        FormsModule,
        MatTooltipModule,
        MatTreeModule,
        MatSliderModule,
        MatAutocompleteModule,
        MatChip,
        AdminComponent,
        SiteCardComponent,
        BadgeCardComponent,
        BadgeDialogComponent,
        TagsCardComponent,
        UsersCardComponent,
        ContentCardComponent,
        ContentAdminComponent,
        UserAdminComponent,
        TagAdminComponent,
        MergeTagDialogComponent,
        EditTagDialogComponent,
        StreamAdminComponent,
        AssetStreamDialogComponent,
        UserDetailDialogComponent,
        UpgradeCardComponent,
        BillingAdminComponent,
        InviteDialogComponent,
        StorageDialogComponent,
        DeleteCardComponent,
        DeleteDialogComponent,
        UserRoleDialogComponent,
        TransferDialogComponent,
    ],
})
export class AdminModule {}
